import { useEffect, useState, useMemo } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { ICategory } from 'shared/interfaces/ITalent';
import { profileService } from 'shared/services/profileService';
import { talentService } from 'shared/services/talentService';
import { FetchingCont, HiddenHeader, HiddenSection, ResumeContentCont } from './Resume.styles';
import ResumeItem from './ResumeItem';
import { arrayMove } from '@dnd-kit/sortable';
import { CircularProgress, useTheme } from '@material-ui/core';
import { Fetching } from '../ImagesVideoAudio/image-video-audio.styles';
import { arraysEqual } from 'shared/utils/common';
import { useNotificationModal } from '@room-match/shared-ui-components';
import { IProfileGraphQL } from 'shared/interfaces/IProfile';
import { CustomTypography } from 'shared/elements/CustomTypography';

const { getResume } = talentService();
const { getSingleProfileGraphQL, getProfileTabDetail, updateProfile } = profileService();

interface Props {
  setCredits: (count: number) => void;
  permissions: string[];
}

function ResumeContent({ setCredits, permissions }: Props) {
  const theme = useTheme();
  const {
    handleOpen: notifOpen,
    isOpen: isNotifOpen,
    NotificationModal,
    handleSetMessage: notifMessage,
  } = useNotificationModal({
    type: 'warning',
  });

  const { profileId } = useParams() as { profileId: string };
  const queryClient = useQueryClient();
  const { data: talentResumeData, isLoading } = getResume();
  const { data: profileResumeData } = getProfileTabDetail(profileId, 'resume');
  const { data: profileData } = getSingleProfileGraphQL(profileId);
  const { mutateAsync: updateProfileMutateAsync } = updateProfile();
  const [resume, setresume] = useState<ICategory[]>([]);
  const [resumeProfile, setResumeProfile] = useState<IProfileGraphQL['resume']>();

  const [filteredTalentResumeData, setfilteredTalentResumeData] = useState<ICategory[]>([]);

  const isNonrepre = useMemo(() => profileData?.data.profile.representation_type === 'non_represented', [profileData]);

  useEffect(() => {
    if (profileData) {
      const res = profileData?.data.profile.resume;
      setResumeProfile(res);
    }
  }, [profileData]);

  // useEffect(() => {
  //   if (profileResumeData) {
  //     console.log({ profileResumeData });

  //     if (profileResumeData.data.attributes.resume) {
  //       setresume(profileResumeData.data.attributes.resume);
  //       let totalCredits = 0;
  //       profileResumeData.data.attributes.resume.map(
  //         (section: ICategory) => (totalCredits = totalCredits + section.credits.length),
  //       );
  //       setCredits(totalCredits);
  //       setloading(false);
  //     }
  //   }
  // }, [profileResumeData, setCredits]);

  useEffect(() => {
    console.log({ talentResumeData }, { resumeProfile });

    if (talentResumeData && resumeProfile) {
      if (talentResumeData.data.attributes.resume) {
        const res = resumeProfile?.map((m) => {
          return talentResumeData.data.attributes.resume.categories?.filter((f) => f.category_id === m.category_id)[0];
        });
        const fil = talentResumeData.data.attributes.resume.categories?.filter(
          (f) => resumeProfile.map((r) => r.category_id).indexOf(f.category_id) === -1,
        );
        const filteredRes = res.filter(function (element) {
          return element !== undefined;
        });
        setresume(filteredRes);

        setfilteredTalentResumeData(fil);
        let totalCredits = 0;
        res?.map((section: ICategory) => (totalCredits = totalCredits + section?.credits?.length));
        setCredits(totalCredits);
      }
    }
  }, [talentResumeData, resumeProfile]);

  //   return items.filter((item) => !sections.some((section) => section.title === item.title));
  // }, [talentResumeData, sections]);

  // useEffect(() => {
  //   const fil = resume.filter((f) => resumeProfile.indexOf(f.category_id) === -1);
  //   setfilteredTalentResumeData(fil);
  // }, [resume, resumeProfile]);

  const grid = 8;

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
    borderRadius: 8,
    margin: 10,
    display: 'flex',
    userSelect: 'none',
    height: 58,
    border: isDragging ? '2px solid #2d343e' : 'none',

    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver: boolean) => ({
    background: theme.palette.type === 'dark' ? (isDraggingOver ? '#151a21' : '#0b0f14') : '#fff',
    padding: grid,
    felx: 1,
    transition: '300ms',
  });

  const errorHandler = () => {
    notifMessage(
      'Warning',
      `You are not allowed to modify your resume. Only your representative on this profile can update this information. Please contact your representative.`,
      'OK',
    );
    notifOpen();
  };

  const profileUpdater = (data: ICategory[]) => {
    updateProfileMutateAsync(
      {
        profileId,
        payload: {
          resume: data?.map((section) => section.category_id),
        },
      },
      {
        onSuccess: () => {
          if (profileResumeData) {
            // queryClient.setQueriesData<IProfileTabDetailReponsePayload>(['profile_tab', profileId, 'resume'], {
            //   data: {
            //     ...profileResumeData.data,
            //     attributes: {
            //       ...profileResumeData.data.attributes,
            //       resume: resume
            //     },
            //   },
            // });
          }
          queryClient.invalidateQueries(['profile', profileId]);
        },
      },
    );
  };

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    if (!permissions?.includes('Resume Categories') && permissions && !isNonrepre) {
      return errorHandler();
    }

    const swappedArray = arrayMove(resume, result.source.index, result.destination.index);

    if (arraysEqual(swappedArray, resume)) return;
    setresume(swappedArray);
    profileUpdater(swappedArray);
  };

  const handleSelectResume = (section: ICategory) => {
    const newSections = [...resume, section];
    setresume(newSections);
    profileUpdater(newSections);
  };

  const handleHideResume = (section: ICategory) => {
    const filteredSections = resume.filter((_section) => _section.category_id !== section.category_id);
    setresume(filteredSections);
    profileUpdater(filteredSections);
  };

  const handleToggle = (section: ICategory, isActive: boolean) => {
    if ((!permissions || !permissions?.includes('Resume Categories')) && !isNonrepre) {
      return errorHandler();
    }
    if (isActive) {
      handleHideResume(section);
    } else {
      setfilteredTalentResumeData((s) => s.filter((f) => f.category_id !== section.category_id));
      handleSelectResume(section);
    }
  };

  return (
    <ResumeContentCont>
      {isLoading ? (
        <FetchingCont>
          <CircularProgress style={{ marginRight: 10, width: 22, height: 22 }} />
          Fetching Data...
        </FetchingCont>
      ) : (
        <>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                  {resume?.length > 0 ? (
                    resume?.map((item: ICategory, index: number) => (
                      <Draggable
                        key={item?.category_id}
                        draggableId={`${item?.category + index + item?.category_id}`}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          >
                            {item && (
                              <ResumeItem
                                last={resume?.length === 0}
                                isActive
                                key={item?.category_id}
                                item={item}
                                handleToggle={handleToggle}
                                allowToggle={
                                  !isNonrepre ? permissions?.includes('Resume Categories') || !permissions : true
                                }
                              />
                            )}
                          </div>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <Fetching>
                      <CustomTypography fontSize={18}>No Resume Selected</CustomTypography>
                      {profileResumeData?.data.attributes.resume ? (
                        <CustomTypography fontSize={15}>
                          You can select from Resume below or create a new one.
                        </CustomTypography>
                      ) : (
                        <CustomTypography fontSize={15}>
                          You can create new a Resume going to 'Resume Tab' under 'My Info'.
                        </CustomTypography>
                      )}
                    </Fetching>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <HiddenSection>
            {filteredTalentResumeData?.length ? <HiddenHeader>Hidden From Profile</HiddenHeader> : <></>}
            {talentResumeData &&
              filteredTalentResumeData?.map((item: ICategory, index: number) => (
                <div style={{ margin: '15px 20px' }} key={index}>
                  {item && <ResumeItem last={false} key={item?.category_id} item={item} handleToggle={handleToggle} />}
                </div>
              ))}
          </HiddenSection>
        </>
      )}
      {isNotifOpen && <NotificationModal />}
    </ResumeContentCont>
  );
}

export default ResumeContent;
